/* eslint-disable react-hooks/exhaustive-deps */
import { Formik } from "formik";

import Spinner from "../../../../../components/Spinner/index";
import InputFormik from "../../../../../components/InputFormik";
import "./index.scss";
import useFormStore from "../store/useStore";
import { remask } from "../../../../../libs/remask-mask";
import Input from "../../../../../components/Input";
import InputSelect from "../../../../../components/Input-select";

function formatarContaBancaria(conta) {
  // Remover qualquer caractere não numérico
  conta = conta.replace(/[^0-9A-Z]/gi, '');

  // Verificar se é o formato 9999999-AA (7 dígitos + 2 letras)
  if (conta.length === 9) {
    return conta.replace(/(\d{7})([0-9A-Z]{2})/i, '$1-$2');
  }

  // Verificar se é o formato 999999999-A (9 dígitos + 1 letra)
  if (conta.length === 10) {
    return conta.replace(/(\d{9})([0-9A-Z]{1})/i, '$1-$2');
  }

  // Caso não se encaixe em nenhum dos formatos, retornar a conta original
  return conta;
}

function FormBankDetails() {
  const { updateValue, setUpdateValueObj } = useFormStore();
  const { modo } = useFormStore();
  const { needSpinner } = useFormStore();
  const { saveOrSchedule, dateSchedule, handleSetDate } = useFormStore();

  return (
    <Spinner status={needSpinner}>
      <div className="collaboratorContainer">
        <div className="title-form form-box-title">
          {modo === "create" ? (
            <h1 className="align-self-end">Adicionar dados bancários - {updateValue.name || "profissional"}</h1>
          ) : (
            <h1 className="align-self-end">Atualizar dados bancários - {updateValue.name || "profissional"}</h1>
          )}
          {saveOrSchedule == "schedule" && (
            <div className="schuduleContainer">
              <div className="calendar">
                <Input label="Data Agendamento" name="teste" placeholder="" value={dateSchedule} setValue={handleSetDate} type="date" />
              </div>
            </div>
          )}
        </div>

        <Formik initialValues={updateValue.bank_data} onSubmit={() => {}}>
          {(props) => (
            <form className="form-container box-form title-form" onSubmit={props.handleSubmit}>
              <div className="row-bank box-row">
                <InputFormik
                  className="form-input"
                  label="Banco"
                  name="bank"
                  onChange={(e: any) => {
                    setUpdateValueObj("bank_data", e.target);
                    props.handleChange(e);
                  }}
                  onBlur={props.handleBlur}
                  value={props.values.bank}
                  placeholder="Digite o nome do Banco"
                  type="text"
                  required={false}
                  autofocus={true}
                />
                <InputFormik
                  className="form-input"
                  label="Agência"
                  name="agency"
                  onChange={(e: any) => {
                    setUpdateValueObj("bank_data", e.target);
                    props.handleChange(e);
                  }}
                  onBlur={props.handleBlur}
                  value={props.values.agency}
                  placeholder="Digite o numero da sua Agência"
                  type="text"
                  required={false}
                  maxlength="5"
                />
              </div>
              <div className="row-bank box-row">
                <InputFormik
                  className="form-input"
                  name="account"
                  onChange={(e: any) => {
                    setUpdateValueObj("bank_data", e.target);
                    props.handleChange(e);
                  }}
                  onBlur={props.handleBlur}
                  value={props.values.account && props.values.account !== "" ? formatarContaBancaria(props.values.account) : props.values.account}
                  label="Conta + Dígito"
                  placeholder="Digite o número da sua conta e o dígito"
                  type="text"
                  required={false}
                />
                <InputSelect
                  name="person_entity"
                  label="Modelo da Conta"
                  list={[
                    { value: 1, label: "Pessoa Física (PF)" },
                    { value: 2, label: "Pessoa Jurídica (PJ)" },
                  ]}
                  value={updateValue?.bank_data?.person_entity || 0}
                  onChange={(e: any) => setUpdateValueObj("bank_data", e.target)}
                  className="h-14 person-entity-select"
                />
              </div>
            </form>
          )}
        </Formik>
      </div>
    </Spinner>
  );
}

export default FormBankDetails;
